<ng-container *ngIf="showChrome; else plainNumber">
  <div class="dashboard-widget-card" [class.dashboard-widget-card--number]="displayType === 'NUMBER'">
    <app-widget-card-header
      [title]="widget.title"
      [isMockPreview]="isMockPreview"
      [isEditable]="isEditable"
      [canDelete]="canDelete"
      [isEditMode]="isEditMode"
      [sensorTypeLabels]="sensorTypeLabels"
      (edit)="edit.emit()"
      (remove)="remove.emit()">
    </app-widget-card-header>

    <div class="dashboard-widget-card__content">
      <ng-container *ngTemplateOutlet="plainNumber"></ng-container>
    </div>
  </div>
</ng-container>

<ng-template #plainNumber>
  <div
    class="widget-number"
    [class.widget-number--metric]="displayType === 'NUMBER'"
    [class.widget-number--device]="isDeviceValue"
    [class.widget-number--area-property-source]="isAreaPropertyValue">
    <div class="widget-number__main" [class.widget-number__main--area-property]="isAreaPropertyValue" *ngIf="displayType === 'NUMBER'; else stackedNumber">
      <span
        class="widget-number__value"
        [class.widget-number__value--empty]="!hasValue"
        [class.widget-number__value--text]="isTextValue"
        [class.widget-number__value--area-property]="isAreaPropertyValue"
        [class.widget-number__value--area-property-long]="isLongAreaPropertyValue"
        [class.widget-number__value--area-property-very-long]="isVeryLongAreaPropertyValue"
        [style.color]="valueColor"
        [attr.title]="valueTooltip">{{ value }}</span>
      <div class="widget-number__side" [class.widget-number__side--area-property]="isAreaPropertyValue" *ngIf="hasValue && (unit || lastDate)">
        <span class="widget-number__unit" *ngIf="unit">{{ unit }}</span>
        <span class="widget-number__date" *ngIf="lastDate">{{ lastDate | date:'short' }}</span>
      </div>
    </div>
    <span class="widget-number__label" *ngIf="displayLabel">{{ displayLabel }}</span>

    <ng-template #stackedNumber>
      <div class="widget-number__main" [class.widget-number__main--area-property]="isAreaPropertyValue">
        <span
          class="widget-number__value"
          [class.widget-number__value--empty]="!hasValue"
          [class.widget-number__value--text]="isTextValue"
          [class.widget-number__value--area-property]="isAreaPropertyValue"
          [class.widget-number__value--area-property-long]="isLongAreaPropertyValue"
          [class.widget-number__value--area-property-very-long]="isVeryLongAreaPropertyValue"
          [style.color]="valueColor"
          [attr.title]="valueTooltip">{{ value }}</span>
        <span class="widget-number__unit" *ngIf="hasValue && unit">{{ unit }}</span>
      </div>
      <span class="widget-number__label" *ngIf="displayLabel">{{ displayLabel }}</span>
      <div class="widget-number__meta">
        <span *ngIf="lastDate">Actualizado {{ lastDate | date:'short' }}</span>
      </div>
    </ng-template>
  </div>
</ng-template>
